import { render } from "./InterfaceLoading.vue?vue&type=template&id=3fb34c1f&scoped=true"
import script from "./InterfaceLoading.vue?vue&type=script&lang=js"
export * from "./InterfaceLoading.vue?vue&type=script&lang=js"

import "./InterfaceLoading.vue?vue&type=style&index=0&id=3fb34c1f&scoped=true&lang=scss"

import exportComponent from "/tmp/5ea1362f-94e3-43d0-86d7-afc144980eef/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb34c1f"]])

export default __exports__